<app-navbar></app-navbar>

<div class="container mx-auto min-h-[50vh] pt-36">
    <div class="justify-content-center">
        <div class="text-center">
            <div class="flex items-center justify-center mb-5">
                <img src="/assets/logo.webp" class="w-64" alt="Logo PRINX" srcset="">
            </div>
            <h1 class="text-5xl">404</h1>
            <p class="font-bold text-xl">Page Not Found</p>
                
            <!-- Component: Base primary basic button -->
            <a href="/" routerLink="/" routerLinkActive="router-link-active" >
                <button class="cursor-pointer mt-3 inline-flex items-center justify-center h-10 gap-2 px-5 text-sm font-medium tracking-wide text-white transition duration-300 rounded-full focus-visible:outline-none whitespace-nowrap bg-emerald-500 hover:bg-emerald-600 focus:bg-emerald-700 disabled:cursor-not-allowed disabled:border-emerald-300 disabled:bg-emerald-300 disabled:shadow-none">
                        <span>Página principal</span>
                </button>
            <!-- End Base primary basic button -->
            </a>
        </div>
    </div>
</div>

<app-footer></app-footer>